/*
 * Avelia COD order popup.
 * Replaces Shopify checkout: any checkout button/link opens this popup.
 * The payload sent to {endpoint}/api/create-order matches the previous
 * full-page COD checkout (assets/cod-checkout.js) so the backend is unchanged.
 * Page mode (data-mode="page", /pages/checkout): the same form is the page itself — the cart loads
 * right away, and there is nothing to open or close.
 */
(function () {
  var root = document.getElementById('ApOrder');
  if (!root) return;
  var pageMode = root.dataset.mode === 'page';

  var CFG = {
    endpoint: (root.dataset.endpoint || '').replace(/\/+$/, ''),
    thankYou: root.dataset.thankYou || '/pages/thank-you',
    moneyFormat: root.dataset.moneyFormat || '{{amount}}',
    currency: root.dataset.currency || 'KZT',
    phonePrefix: '+7',
    addressFallback: 'Вам напишут в WhatsApp для уточнения',
    country: 'Kazakhstan',
    discountPercent: parseFloat(root.dataset.discountPercent || '0') || 0,
    // free delivery shown as an items line (snippets/ap-delivery-item.liquid); display only
    delivery: root.dataset.deliveryTitle ? {
      title: root.dataset.deliveryTitle,
      compare: parseInt(root.dataset.deliveryCompare || '0', 10) || 0,
      free: root.dataset.deliveryFree || 'Бесплатно',
      image: root.dataset.deliveryImage || '',
    } : null,
  };

  var form = root.querySelector('[data-form]');
  var itemsEl = root.querySelector('[data-items]');
  var totalEl = root.querySelector('[data-total]');
  var summaryEl = root.querySelector('[data-summary]');
  var emptyEl = root.querySelector('[data-empty]');
  var errorEl = root.querySelector('[data-error]');
  var submitBtn = root.querySelector('[data-submit]');
  var discountLine = root.querySelector('[data-discount-line]');
  var cart = null;
  var submitting = false;
  var lastFocus = null;

  function money(cents) {
    var v = Math.round(cents / 100).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
    return CFG.moneyFormat.replace(/\{\{\s*[a-z_]+\s*\}\}/, v);
  }
  function esc(s) {
    var d = document.createElement('div');
    d.appendChild(document.createTextNode(s == null ? '' : String(s)));
    return d.innerHTML;
  }
  function cookie(name) {
    var m = document.cookie.match(new RegExp('(?:^|;\\s*)' + name + '=([^;]*)'));
    return m ? decodeURIComponent(m[1]) : '';
  }
  function landingUrl() {
    try { return localStorage.getItem('avelia_landing_url') || location.href; } catch (e) { return location.href; }
  }

  function deliveryLine() {
    var d = CFG.delivery;
    if (!d) return '';
    return '<li class="ap-order__item ap-order__item--delivery">' +
      (d.image ? '<img src="' + esc(d.image) + '" alt="" width="64" height="64" loading="lazy">' : '<span class="ap-order__noimg"></span>') +
      '<div class="ap-order__item-info"><div class="ap-order__item-title">' + esc(d.title) + '</div></div>' +
      // right column: the regular price struck through, «Бесплатно» under it
      '<div class="ap-order__item-price ap-order__item-price--free">' +
        (d.compare > 0 ? '<s>' + money(d.compare) + '</s>' : '') + '<span>' + esc(d.free) + '</span></div></li>';
  }

  function render() {
    root.classList.remove('is-loading'); // page mode: shown once the cart is in
    var empty = !cart || cart.item_count === 0;
    summaryEl.hidden = empty;
    form.hidden = empty;
    emptyEl.hidden = !empty;
    if (empty) return;
    itemsEl.innerHTML = cart.items.map(function (it) {
      var img = it.image ? it.image.replace(/(\.[a-z]+)(\?|$)/i, '_160x160$1$2') : '';
      var title = (it.product_title || '').split(' - ')[0];
      var sub = [(it.product_title || '').split(' - ')[1], it.variant_title].filter(Boolean).join(' · ');
      return '<li class="ap-order__item" data-key="' + esc(it.key) + '">' +
        (img ? '<img src="' + esc(img) + '" alt="" width="64" height="64" loading="lazy">' : '<span class="ap-order__noimg"></span>') +
        '<div class="ap-order__item-info"><div class="ap-order__item-title">' + esc(title) + '</div>' +
        '<div class="ap-order__item-sub">' + esc(sub) + '</div>' +
        '<div class="ap-order__item-ctrl">' +
          '<div class="ap-order__qty">' +
            '<button type="button" data-qty-step="-1" aria-label="Уменьшить количество">\u2212</button>' +
            '<span aria-live="polite">' + it.quantity + '</span>' +
            '<button type="button" data-qty-step="1" aria-label="Увеличить количество">+</button>' +
          '</div>' +
          '<button type="button" class="ap-order__remove" data-remove>Удалить</button>' +
        '</div></div>' +
        '<div class="ap-order__item-price">' + money(it.final_line_price) + '</div></li>';
    }).join('') + deliveryLine();
    // multi-item discount: every unit after the most expensive one (same rule as the order server)
    var units = [];
    cart.items.forEach(function (it) { for (var q = 0; q < it.quantity; q++) units.push(it.final_price); });
    var disc = 0;
    if (units.length > 1 && CFG.discountPercent > 0) {
      var sum = units.reduce(function (a, b) { return a + b; }, 0);
      disc = Math.round((sum - Math.max.apply(null, units)) * CFG.discountPercent / 100 / 100) * 100;
    }
    discountLine.hidden = disc <= 0;
    if (disc > 0) {
      root.querySelector('[data-discount-label]').textContent = 'Скидка ' + CFG.discountPercent + '% на доп. товары';
      root.querySelector('[data-discount]').textContent = '\u2212' + money(disc);
    }
    totalEl.textContent = money(cart.total_price - disc);
  }

  // Edit the cart from the popup: quantity steps and removal (Shopify /cart/change.js).
  // The header bubble and the cart drawer are refreshed from the same response.
  var busy = false;
  function sectionHTML(html, selector) {
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var el = doc.querySelector(selector);
    return el ? el.innerHTML : null;
  }
  function changeLine(key, quantity) {
    if (busy) return;
    busy = true;
    root.classList.add('is-updating');
    errorEl.hidden = true;
    fetch('/cart/change.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: key, quantity: quantity, sections: 'cart-icon-bubble,cart-drawer', sections_url: location.pathname }),
    })
      .then(function (r) { return r.json().then(function (d) { return { ok: r.ok, d: d }; }); })
      .then(function (res) {
        if (!res.ok) throw new Error(res.d.description || res.d.message || 'Не удалось изменить корзину');
        var sections = res.d.sections || {};
        delete res.d.sections;
        cart = res.d;
        render();
        var bubble = document.getElementById('cart-icon-bubble');
        var bubbleHTML = sections['cart-icon-bubble'] && sectionHTML(sections['cart-icon-bubble'], '.shopify-section');
        if (bubble && bubbleHTML !== null) bubble.innerHTML = bubbleHTML;
        var drawer = document.getElementById('CartDrawer');
        var drawerHTML = sections['cart-drawer'] && sectionHTML(sections['cart-drawer'], '#CartDrawer');
        if (drawer && drawerHTML !== null) drawer.innerHTML = drawerHTML;
        var drawerEl = document.querySelector('cart-drawer');
        if (drawerEl) drawerEl.classList.toggle('is-empty', cart.item_count === 0);
      })
      .catch(function (err) {
        errorEl.textContent = err.message;
        errorEl.hidden = false;
      })
      .finally(function () {
        busy = false;
        root.classList.remove('is-updating');
      });
  }
  itemsEl.addEventListener('click', function (e) {
    var li = e.target.closest('[data-key]');
    if (!li || !cart) return;
    var item = cart.items.find(function (i) { return i.key === li.dataset.key; });
    if (!item) return;
    var step = e.target.closest('[data-qty-step]');
    if (step) changeLine(item.key, Math.max(0, item.quantity + Number(step.dataset.qtyStep)));
    else if (e.target.closest('[data-remove]')) changeLine(item.key, 0);
  });

  function trackInitiateCheckout() {
    if (typeof fbq !== 'function' || !cart || !cart.item_count) return;
    try {
      fbq('track', 'InitiateCheckout', {
        content_ids: cart.items.map(function (i) { return String(i.variant_id); }),
        contents: cart.items.map(function (i) { return { id: String(i.variant_id), quantity: i.quantity }; }),
        content_type: 'product',
        num_items: cart.item_count,
        value: cart.total_price / 100,
        currency: CFG.currency,
      });
    } catch (e) {}
  }

  function open() {
    if (pageMode) return;
    lastFocus = document.activeElement;
    var drawer = document.querySelector('cart-drawer');
    if (drawer && drawer.classList.contains('active') && typeof drawer.close === 'function') drawer.close();
    root.hidden = false;
    document.documentElement.classList.add('ap-order-open');
    requestAnimationFrame(function () { root.classList.add('is-open'); });
    load();
  }

  // the cart into the form, then InitiateCheckout (the form is now in front of the visitor)
  function load() {
    fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (c) {
        cart = c;
        render();
        trackInitiateCheckout();
        var first = form.querySelector('[name="full_name"]');
        // desktop only: on phones focusing the field scrolls the popup away from its top / opens the keyboard
        if (first && cart.item_count && window.matchMedia('(hover: hover) and (pointer: fine)').matches) {
          setTimeout(function () { first.focus(); }, 50);
        }
      })
      .catch(function () { cart = null; render(); });
  }

  function close() {
    if (pageMode) return;
    root.classList.remove('is-open');
    document.documentElement.classList.remove('ap-order-open');
    setTimeout(function () { root.hidden = true; }, 200);
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }

  root.querySelectorAll('[data-close]').forEach(function (el) { el.addEventListener('click', close); });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !root.hidden) close(); });

  // Intercept every way into Shopify checkout.
  document.addEventListener('click', function (e) {
    var t = e.target.closest('[name="checkout"], a[href="/checkout"], a[href^="/checkout?"], a[href*="/checkouts/"], [data-ap-order-open]');
    if (!t || root.contains(t)) return;
    e.preventDefault();
    e.stopPropagation();
    open();
  }, true);
  document.addEventListener('submit', function (e) {
    var f = e.target;
    var action = (f.getAttribute('action') || '');
    if (action.indexOf('/checkout') !== -1 || (e.submitter && e.submitter.name === 'checkout')) {
      e.preventDefault();
      open();
    }
  }, true);
  if (pageMode) load();
  else if (/[?&]ap_order=1/.test(location.search)) open();

  // Phone: digits only, no length cap while typing. A number typed with its 8 / 7 in front (11 digits)
  // goes out as +7 and the other 10 — phoneDigits().
  var phone = form.querySelector('[name="phone"]');
  phone.addEventListener('input', function () {
    var d = phone.value.replace(/\D/g, '');
    if (d !== phone.value) phone.value = d; // only when something was dropped: the caret stays where it is while typing
  });
  function phoneDigits() {
    var d = phone.value.replace(/\D/g, '');
    return d.length === 11 && (d[0] === '7' || d[0] === '8') ? d.slice(1) : d;
  }
  form.addEventListener('input', function (e) {
    var f = e.target.closest('.ap-field');
    if (f) f.classList.remove('is-error');
    errorEl.hidden = true;
  });

  function validate() {
    var ok = true;
    var name = form.querySelector('[name="full_name"]');
    if (!name.value.trim()) { name.closest('.ap-field').classList.add('is-error'); ok = false; }
    // a full local number at least; at most 15 digits with the 7 of +7, as the order server accepts
    var pd = phoneDigits();
    if (pd.length < 10 || pd.length > 14) { phone.closest('.ap-field').classList.add('is-error'); ok = false; }
    return ok;
  }

  function showError(msg) {
    errorEl.textContent = msg;
    errorEl.hidden = false;
  }

  form.addEventListener('submit', function (e) {
    e.preventDefault();
    if (submitting) return;
    if (form.querySelector('[name="cod_hp_field"]').value.trim()) return; // bot
    if (!validate()) return;
    if (!CFG.endpoint) { showError('Оформление временно недоступно. Пожалуйста, свяжитесь с нами.'); return; }
    if (!cart || !cart.item_count) return;

    submitting = true;
    submitBtn.disabled = true;
    submitBtn.classList.add('is-loading');

    var fullName = form.querySelector('[name="full_name"]').value.trim();
    var phoneFull = CFG.phonePrefix + phoneDigits();
    var pm = form.querySelector('[name="payment_method"]:checked');
    var payload = {
      customer: {
        full_name: fullName,
        phone: phoneFull,
        email: '',
        country: CFG.country,
        city: CFG.addressFallback,
        district: '',
        address: CFG.addressFallback,
        zip: '',
      },
      line_items: cart.items.map(function (i) { return { variant_id: i.variant_id, quantity: i.quantity }; }),
      note: '',
      payment_method: pm ? pm.value : '',
      shipping_fee: 0,
      honeypot: '',
      meta: { fbc: cookie('_fbc'), fbp: cookie('_fbp'), user_agent: navigator.userAgent, url_source: landingUrl() },
    };

    fetch(CFG.endpoint + '/api/create-order', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload),
    })
      .then(function (r) { return r.json().then(function (d) { return { ok: r.ok, d: d }; }); })
      .then(function (res) {
        if (!res.ok || !res.d.success) throw new Error(res.d.error || 'Не удалось оформить заказ');
        var o = res.d.order;
        try {
          sessionStorage.setItem('cod_order_summary', JSON.stringify({
            order_name: o.name,
            order_number: o.order_number,
            name: fullName,
            phone: phoneFull,
            email: '',
            address: CFG.addressFallback,
            items: (o.line_items || []).map(function (li) { return { title: li.title, variant: li.variant_title, quantity: li.quantity, price: li.price }; }),
            total_price: o.total_price,
            subtotal_price: o.subtotal_price,
            discount: o.total_discounts || 0,
            discount_label: 'Скидка ' + CFG.discountPercent + '% на доп. товары',
            currency: o.currency,
            shipping: 'Бесплатно',
            status_url: o.status_url,
            date: new Date().toLocaleDateString(),
          }));
        } catch (err) {}
        return fetch('/cart/clear.js', { method: 'POST', credentials: 'same-origin' }).catch(function () {});
      })
      .then(function () { window.location.href = CFG.thankYou; })
      .catch(function (err) {
        submitting = false;
        submitBtn.disabled = false;
        submitBtn.classList.remove('is-loading');
        showError(err && err.message ? err.message : 'Что-то пошло не так. Попробуйте ещё раз.');
      });
  });

  window.ApOrder = { open: open, close: close };
})();
